import { API_BASE, getToken, parseErrorBody } from './client.js'

const API_PATH_TEST = '/test'

export class AutotestsApiError extends Error {
  constructor(message, status, details = null) {
    super(message)
    this.name = 'AutotestsApiError'
    this.status = status
    this.details = details
  }
}

async function testApiJson(path, options = {}, fallbackMessage = 'Request failed') {
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  }
  const token = getToken()
  if (token) headers.Authorization = `Bearer ${token}`

  const res = await fetch(`${API_BASE}${API_PATH_TEST}${path}`, { ...options, headers })
  if (!res.ok) {
    const msg = await parseErrorBody(res).catch(() => fallbackMessage)
    throw new AutotestsApiError(msg || fallbackMessage, res.status)
  }
  return res.json()
}

export async function getAutotestsDashboardSummary() {
  return testApiJson('/dashboard/summary', {}, 'Не удалось загрузить dashboard')
}

export async function getAutotestsAlerts({ limit = 20, offset = 0 } = {}) {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) })
  return testApiJson(`/alerts?${params}`, {}, 'Не удалось загрузить alerts')
}

export async function getAutotestsRuns({ limit = 10, offset = 0, status, sort = 'id_desc' } = {}) {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) })
  if (status) params.set('status', status)
  if (sort) params.set('sort', sort)
  return testApiJson(`/runs?${params}`, {}, 'Не удалось загрузить запуски')
}

export async function getAutotestsRun(runId) {
  return testApiJson(`/runs/${runId}`, {}, 'Не удалось загрузить запуск')
}

export async function getAutotestsRunRounds(runId) {
  return testApiJson(`/runs/${runId}/rounds`, {}, 'Не удалось загрузить раунды запуска')
}

export async function getAutotestsRunMessages(runId) {
  return testApiJson(`/runs/${runId}/messages`, {}, 'Не удалось загрузить сообщения')
}

export async function getAutotestScenarios({ activeOnly } = {}) {
  const params = new URLSearchParams()
  if (activeOnly != null) params.set('active_only', String(Boolean(activeOnly)))
  const suffix = params.toString() ? `?${params}` : ''
  return testApiJson(`/scenarios${suffix}`, {}, 'Не удалось загрузить сценарии')
}

export async function createAutotestScenario(payload) {
  return testApiJson('/scenarios', {
    method: 'POST',
    body: JSON.stringify(payload),
  }, 'Не удалось создать сценарий')
}

export async function enqueueAutotestScenario(scenarioId, payload) {
  return testApiJson(`/scenarios/${scenarioId}/enqueue`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }, 'Не удалось запустить сценарий')
}

export async function enqueueAllAutotestScenarios(payload) {
  return testApiJson('/scenarios/enqueue-all', {
    method: 'POST',
    body: JSON.stringify(payload),
  }, 'Не удалось запустить автотесты')
}

/* ── Start test (no scenarios) ────────────────────────────────── */

export async function startAutotest(payload) {
  return testApiJson('/start', {
    method: 'POST',
    body: JSON.stringify(payload),
  }, 'Не удалось запустить тест')
}

export async function getTestConfigs() {
  return testApiJson('/configs', {}, 'Не удалось загрузить конфигурации')
}

/* ── Prompts ──────────────────────────────────────────────────── */

export async function getTestPrompts() {
  return testApiJson('/prompts', {}, 'Не удалось загрузить промпты')
}

export async function updateTestPrompts(payload) {
  return testApiJson('/prompts', {
    method: 'PUT',
    body: JSON.stringify(payload),
  }, 'Не удалось сохранить промпты')
}

/* ── Analysis ─────────────────────────────────────────────────── */

export async function runAutotestDailyReport() {
  return testApiJson('/analysis/tasks/daily', { method: 'POST' }, 'Не удалось запустить daily report')
}

export async function runAutotestWeeklyReport() {
  return testApiJson('/analysis/tasks/weekly', { method: 'POST' }, 'Не удалось запустить weekly report')
}

export async function buildAutotestAnalysisReport(payload) {
  return testApiJson('/analysis/reports/build', {
    method: 'POST',
    body: JSON.stringify(payload),
  }, 'Не удалось запустить построение отчёта')
}

export async function getAutotestAnalysisReports({ limit = 30, offset = 0 } = {}) {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) })
  return testApiJson(`/analysis/reports?${params}`, {}, 'Не удалось загрузить отчёты анализа')
}
